<template>
  <!-- 作業完了確認ダイアログ -->
  <v-dialog v-model="showDialog" width="100vw" persistent no-click-animation scrollable>
    <v-card>
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>車両一覧編集</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="onCloseButtonClick" text><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row no-gutters class="mt-2 px-2" v-if="isModeAppend">
          <v-col :cols="12" style="font-size: 0.875rem;">
            <dd-spread-sheet
              v-model="rows"
              ref="ddSpreadSheet"
              :column="SpreadHeader"
              :options="option"
              :contextMenu="null"
              :dropDownList="[]"
              :isDeleteBtn="false"
              :isFixedToolBar="false"
              :isDisabledToolbar="false"
              :isDisabledAppend="true"
              @change="onChangeSpreadSheet"
            >
              <span class="text-black-bold" style="margin-top:4px;">操作：</span>
              <dd-icon-button-with-tooltip
                icon="mdi-close-box"
                @click="onCloseButtonClick"
                message="この画面を終了して前の画面へ戻ります"
              />
              <dd-icon-button-with-tooltip
                icon="mdi-sync-circle"
                :disabled="isSaveButtonDisabled"
                @click="onSaveButtonClick"
                message="チェックされた行の入力を車両に反映して前の画面に戻ります"
              />
              <span class="line-left ml-3 px-1" />
              <span class="text-black-bold" style="margin-top:4px;">テンプレート：</span>
              <dd-icon-button-with-tooltip
                icon="mdi-microsoft-excel"
                @click="onClickDownloadTemplate"
                message="テンプレート用EXCELファイルをダウンロードします"
              />
              <a id="download" href="#" style="display: none">ダウンロード</a>
            </dd-spread-sheet>
          </v-col>
        </v-row>
        <div class="mb-4" />
      </v-card-text>
      <v-card-actions>
        <dd-footer-button
          @click="onCloseButtonClick"
          tooltipText="この画面を終了して前の画面へ戻ります"
          :tooltipTop="true"
          :enableToolTip="helpUseFlg"
        >
          <v-icon>mdi-window-close</v-icon>
          閉じる
        </dd-footer-button>

        <!--
        <dd-custom-button
          :outlined="true"
          :minWidth="240"
          @click="onClickDownloadTemplate"
          tooltipText="EXCELテンプレートをダウンロードします"
          :tooltipBottom="true"
          :enableToolTip="helpUseFlg"
          >
          <v-icon>mdi-file-download-outline</v-icon>
          EXCELテンプレートをダウンロード
        </dd-custom-button>
        <a id="sharyoDownload" href="#" style="display: none" />
        -->

        <v-spacer />
        <dd-footer-button
          :disabled="isSaveButtonDisabled"
          @click="onSaveButtonClick"
          tooltipText="入力した内容を反映して前の画面に戻ります"
          :tooltipTop="true"
          :enableToolTip="helpUseFlg">
          <v-icon>mdi-sync</v-icon>
          反映して閉じる
        </dd-footer-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// import DdCustomButton from '@/components/DdCustomButton'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdFooterButton from '@/components/DdFooterButton'
import DdSpreadSheet from '@/components/DdSpreadSheet'

// import date from '@/ddv2.library/date'
import flowMixin from '@/mixins/flowMixins'
// import filter from '@/rahmen/utils/filters'
// import header from '@/ddv2.library/header'
// import dolly from '@/rahmen/utils/dolly'
// import formatter from '@/ddv2.library/utils/formatter'
// import modals from '@/ddv2.library/modals'

import { mapGetters } from 'vuex'

export default {
  name: 'TgPopupSagyoSharyoList',
  mixins: [flowMixin],
  components: {
    // DdCustomButton,
    DdIconButtonWithTooltip,
    DdFooterButton,
    DdSpreadSheet
  },
  props: {
    /**
     * 画面表示フラグ
     */
    showDialog: {
      type: Boolean,
      default: false
    },
    /**
     * 案件NO使用フラグ
     */
    useRefAnkenNo: {
      type: Boolean,
      default: false
    },
    /**
     * 車両リスト
     */
    sharyoList: {
      type: Array
    }
  },
  data: () => ({
    // ページネーション用
    vitemsPerPage: 0,
    vPage: 1,

    headers: [],
    rows: [],
    isModeAppend: false,

    // スプレッドシートオプション
    option: {
      // // テーブル最大高さ
      tableHeight: '55vh',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列固定表示
      freezeColumns: 4,
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: false,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: false,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: false,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: false,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: true,
      // ページネーションオプション
      pagination: 50,
      paginationOptions: [20, 50, 100, 500],
      // デフォルト文言変更
      text: {
        show: '1ページ当たりの行数:',
        entries: '',
        showingPage: '全部で {1} ページあります',
        search: 'さらにフリーワードで絞り込む'
      }
    }
  }),
  created () {
  },
  mounted () {
  },
  computed: {
    ...mapGetters({
      shubetsuList: 'DDMasters/mstShubetsu',
      loginUserId: 'users/userId',
      tgMstHinmeiList: 'DDMasters/vwCMstHinmeiExtTg',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    computedProps () {
      return {
        ...this.$props,
        persistent: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    sonotaHinmokuList () {
      if (!this.uketsukeBuzaiList) return []
      return this.uketsukeBuzaiList.filter((elem) => {
        return elem.himodukeId !== null
      }).sort((a, b) => {
        return a.himodukeId - b.himodukeId
      })
    },
    // DropDownList
    filteredSagyoKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'TGK001')
    },
    filteredBackEyeFormatList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'TGS005')
    },
    filteredEtcFormatList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'TGS006')
    },
    filteredRefrigeratorMakerList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'TGS007')
    },

    // スプレッドシートヘッダー
    SpreadHeader () {
      var wkSharyoMakerList = []
      this.sbtListFilter(this.shubetsuList, 'TGS004').forEach((item) => {
        wkSharyoMakerList.push(item.sbtNm)
      })
      var wkBackeyeMakerList = []
      this.sbtListFilter(this.shubetsuList, 'TGS005').forEach((item) => {
        wkBackeyeMakerList.push(item.sbtNm)
      })
      var wkEtcMakerList = []
      this.sbtListFilter(this.shubetsuList, 'TGS006').forEach((item) => {
        wkEtcMakerList.push(item.sbtNm)
      })
      var wkRefrigeratorMakerList = []
      this.sbtListFilter(this.shubetsuList, 'TGS007').forEach((item) => {
        wkRefrigeratorMakerList.push(item.sbtNm)
      })

      var titleList = [
        { title: '', name: 'id', type: 'hidden' },
        { title: '', name: 'rowNo', type: 'hidden' },
        { title: '変更', name: 'editFlg', type: 'checkbox', customInput: null, readOnly: false, width: '35px' },
        // -- ここから入力項目
        { title: '#', name: 'keyNo', type: 'text', customInput: null, readOnly: false, width: '35px' },
        { title: '案件番号', name: 'refAnkenNo', type: 'text', customInput: null, readOnly: false, width: '120px' },
        { title: '新車番プレートNo', name: 'newShabanPlateNo', type: 'text', customInput: null, readOnly: false, width: '150px' },
        { title: '旧車番プレートNo', name: 'oldShabanPlateNo', type: 'text', customInput: null, readOnly: false, width: '150px' },
        { title: '新車台番号', name: 'newShadaiNo', type: 'text', customInput: null, readOnly: false, width: '150px' },
        { title: '旧車台番号', name: 'oldShadaiNo', type: 'text', customInput: null, readOnly: false, width: '150px' },
        { title: '車両備考', name: 'sharyoBiko', type: 'text', customInput: null, readOnly: false, width: '250px' },
        { title: '車両型式', name: 'sharyoKeishiki', type: 'text', customInput: null, readOnly: false, width: '100px' },
        { title: '初年度登録', name: 'shonendoToroku', type: 'text', customInput: null, readOnly: false, width: '100px' },
        { title: '車両メーカー', name: 'sharyoMakerNm', type: 'dropdown', customInput: null, readOnly: false, source: wkSharyoMakerList, width: '120px' },
        { title: '車種', name: 'shashu', type: 'text', customInput: null, readOnly: false, width: '120px' },
        { title: 'バックアイメーカー', name: 'backeyeKeishikiNm', type: 'dropdown', customInput: null, readOnly: false, source: wkBackeyeMakerList, width: '120px' },
        { title: 'ETCメーカー', name: 'etcKeishikiNm', type: 'dropdown', customInput: null, readOnly: false, source: wkEtcMakerList, width: '150px' },
        { title: '冷凍機メーカー', name: 'refrigeratorMakerNm', type: 'dropdown', customInput: null, readOnly: false, source: wkRefrigeratorMakerList, width: '120px' },
        { title: 'ドア番', name: 'doorNo', type: 'text', customInput: null, readOnly: false, width: '120px' }
      ]

      return titleList
    },
    computedColNumList () {
      var result = {}
      this.SpreadHeader.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    },
    // 保存ボタン活性条件
    isSaveButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true
      })
      if (saveTargetRow.length < 1) {
        return true
      }
      return false
    }
  },
  watch: {
    showDialog: function () {
      if (this.showDialog) {
        this.initialize()
      }
    },
    searchText: function () {
      this.$nextTick(() => { this.onResize() })
    }
  },
  methods: {
    onCloseButtonClick: function (e) {
      this.closeDialog()
    },
    onSaveButtonClick: function (e) {
      const self = this
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true
      })
      if (saveTargetRow.length < 1) { return }

      saveTargetRow.map((elem) => {
        elem.id = [undefined, null, ''].includes(elem.id) ? 0 : elem.id
        // 数値変換
        elem.hyojiOrder = elem.hyojiOrder ? self.getNullValue(elem.hyojiOrder) : null
        return elem
      })

      saveTargetRow.map((elem) => {
        // --------------------------------------------------
        // コード変換
        // --------------------------------------------------
        elem.sharyoMaker = null
        elem.backeyeKeishiki = null
        elem.etcKeishiki = null
        elem.refrigeratorMaker = null
        // 車両メーカー
        if (![undefined, null, ''].includes(elem.sharyoMakerNm)) {
          elem.sharyoMaker = self.getSbtCd('TGS004', elem.sharyoMakerNm)
        }
        // バックアイメーカー
        if (![undefined, null, ''].includes(elem.backeyeKeishikiNm)) {
          elem.backeyeKeishiki = self.getSbtCd('TGS005', elem.backeyeKeishikiNm)
        }
        // ETCメーカー
        if (![undefined, null, ''].includes(elem.etcKeishikiNm)) {
          elem.etcKeishiki = self.getSbtCd('TGS006', elem.etcKeishikiNm)
        }
        // 冷凍機メーカー
        if (![undefined, null, ''].includes(elem.refrigeratorMakerNm)) {
          elem.refrigeratorMaker = self.getSbtCd('TGS006', elem.refrigeratorMakerNm)
        }
        return elem
      })
      this.$emit('save', saveTargetRow)
    },
    getSbtCd: function (sbtShuruiCd, sbtNm) {
      const x = this.shubetsuList.filter((item) => {
        return item.sbtShuruiCd === sbtShuruiCd && item.sbtNm === sbtNm
      })
      if (x !== null && x.length > 0) {
        return x[0].sbtCd
      } else {
        return null
      }
    },

    // テンプレートEXCELダウンロード
    onClickDownloadTemplate: function () {
      this.isExcelDownloader = true
      this.HttpClient
        .requestFileByPost('/api/v1/Tgrcod0021/TemplateDownloadforSharyoList')
        .then((data) => {
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('sharyoDownload')
          this.isExcelDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = 'template.xlsx'
          elem.click()
        })
    },

    // --------------------------------------------------
    // 初期化
    // --------------------------------------------------
    initialize () {
      console.log('initialize', this.sharyoList)
      this.isModeAppend = true
      this.rows = []
      this.sharyoList.forEach((item) => {
        const newrow = {
          id: 0,
          editFlg: false,
          editMode: false,
          rowNo: this.rows.length + 1,
          //
          keyNo: item.keyNo,
          newShabanPlateNo: item.newShabanPlateNo,
          oldShabanPlateNo: item.oldShabanPlateNo,
          newShadaiNo: item.newShadaiNo,
          oldShadaiNo: item.oldShadaiNo,
          sharyoBiko: item.sharyoBiko,
          sharyoKeishiki: item.sharyoKeishiki,
          shonendoToroku: item.shonendoToroku,
          sharyoMakerNm: item.sharyoMakerNm,
          shashu: item.shashu,
          backeyeKeishikiNm: item.backeyeKeishikiNm,
          etcKeishikiNm: item.etcKeishikiNm,
          refrigeratorMakerNm: item.refrigeratorMakerNm,
          doorNo: item.doorNo,
          refAnkenNo: item.refAnkenNo
        }
        this.rows.push(newrow)
      })
    },
    closeDialog () {
      this.$emit('close')
    },

    // スプレッドシート操作
    onChangeSpreadSheet: function (el, cell, x, y, value, oldValue, rowId) {
      // console.log('onChangeSpreadSheet', el, cell, x, y, value, oldValue, rowId)
      // 変更チェックボックスは除外
      if (['2', 2].includes(x)) return

      // 対象項目列の全ての値を取得
      const targetIndex = this.rows.findIndex((item) => item.rowNo === rowId)
      if (targetIndex >= 0) {
        // const modifyMark = this.rows[targetIndex].delFlg ? '－' : this.rows[targetIndex].id > 0 ? '＊' : '＋'
        // this.$refs.ddSpreadSheet.setValueFromCoords(this.computedColNumList.memo, y, modifyMark, true)
        this.$refs.ddSpreadSheet.setValueFromCoords(this.computedColNumList.editFlg, y, true, true)
      }
    },
    // ----------------------------------------------------------------------
    dummyfunction () {
      return true
    }
  }
}
</script>
<style scoped>
</style>
